window.addEventListener('load', () => {
  // コレクション一覧 商品画像用スライダー
  var swiper = new Swiper(".product-images-swiper", {
      loop: false,
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      autoHeight: isSpecialPage(),
  });

  // 特定のページのみautoHeightをtrueにする
  function isSpecialPage() {
      return window.location.href.includes("salon-allmenu");
  }

  const swatchLists = document.querySelectorAll('.ProductItem__ColorSwatchList');

  // 各イベント
  swatchLists.forEach((swatchList, productIndex) => {
      swatchList.querySelectorAll('.ProductItem__ColorSwatchItem').forEach((swatch, swatchIndex) => {
          // 初回ロード時
          if (swatch.querySelector(".ColorSwatch__Radio").checked) { // checkedがついてるカラー
              changeCarouselImages(swatch, productIndex, swatchList);
          }

          // カラースウォッチ変更時
          swatch.querySelector(".ColorSwatch__Radio").addEventListener('click', () => {
              console.log('aaa');
              changeCarouselImages(swatch, productIndex, swatchList);
          });
      });
  });

  /******************************************************
  *  選択されている色ごとに異なる商品画像をカルーセルに表示    *
  *******************************************************/
  function changeCarouselImages(swatch, productIndex, swatchList) {
      const clickedColor = swatch.querySelector('.ColorSwatch').title;
      const productObj = productImgInfoArray[productIndex]; //商品のオブジェクト(productImgInfoArrayはproduct-item.liquidで作成)
      
      // クリックした商品の配列を画像の小さい数順に並び変える
      productObj.sort((a, b) => a.imgStartIndex - b.imgStartIndex);
      
      // クリックしたカラーのオブジェクトのimgStartIndex(①)を取得
      const selectedColorIndex = productObj.findIndex((variant) => variant.color === clickedColor);
      const selectedColorStartImgIndex = productObj[selectedColorIndex].imgStartIndex;
      
      // 次の配列のカラーのimgStartIndex(②)を取得
      const nextColorStartImgIndex = productObj[selectedColorIndex + 1]?.imgStartIndex;
      
      // カルーセル画像要素を取得
      const productImages = swatchList.closest('.ProductItem').querySelectorAll('.product-images-swiper .swiper-wrapper .swiper-slide');

      // 商品の全画像に対してdisplay:none or blockを付与
      productImages.forEach((image, index) => {
          if (nextColorStartImgIndex) {
              if (selectedColorStartImgIndex <= index && index < nextColorStartImgIndex) {
                  image.style.display = 'block';
              } else {
                  image.style.display = 'none';
              }
          } else {
              if (selectedColorStartImgIndex <= index) {
                  image.style.display = 'block';
              } else {
                  image.style.display = 'none';
              }
          }
      });
      
      swatchList.closest('.ProductItem').querySelector('.swiper').swiper.update(); // スライダー再読み込み(display:blockの要素だけで全体幅を設定するため)
      swatchList.closest('.ProductItem').querySelector('.swiper').swiper.slideTo(0, false); // バリエーション先頭の画像を表示
  }

  // predictive search カルーセル対応
  const targetElement = document.querySelector('.Search__Inner'); // predictive search要素

  // Check if targetElement is found
  if (targetElement) {
      const observer = new MutationObserver((mutationsList, observer) => {
          // Predictive searchが表示された時
          var swiper = new Swiper(".product-images-swiper", {
              loop: false,
              centeredSlides: true,
              slidesPerView: 1,
              spaceBetween: 0,
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },
          });

          // 監視を停止
          observer.disconnect();
      });

      // 監視対象の設定
      const config = { childList: true, subtree: true };

      // 変異監視者を開始
      observer.observe(targetElement, config);
  } else {
      console.error('Target element for MutationObserver not found.');
  }
});

{
var swiper = new Swiper(".article-shortcode-swiper", {
    loop: true,
    autoplay: {
      delay: 3000,
    },
    effect: 'fade',
    speed: 700,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}